import { Caption, COLORS, Panel, Badge } from './ui'

const STEPS = [1, 0.72, 0.45, 0.2, 0]  // noise level per denoising step

// NEW chapter — generative vision: diffusion turns noise into an image, plus a
// nod to 3D (Gaussian splatting) and video, the other 2026 frontiers.
export function Generative2D() {
  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto',
      alignItems: 'center', justifyContent: 'center', gap: 16, padding: '90px 24px 110px',
      fontFamily: "'General Sans', system-ui, sans-serif", textAlign: 'center', color: COLORS.text,
    }}>
      <Badge color={COLORS.pink}>Generative Vision — making pixels</Badge>

      <div style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: 14, color: COLORS.textDim }}>
        prompt: <span style={{ color: '#fff' }}>“a cat in warm sunlight”</span>
      </div>

      {/* Denoising strip */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        {STEPS.map((noise, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5 }}>
              <div style={{ position: 'relative', width: 96, height: 96, borderRadius: 8, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.12)' }}>
                <img src="/cv/ref-cat.png" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', filter: `blur(${noise * 6}px)` }} />
                <div style={{
                  position: 'absolute', inset: 0, opacity: noise,
                  backgroundImage: 'repeating-conic-gradient(#888 0% 25%, #222 0% 50%)',
                  backgroundSize: '4px 4px', mixBlendMode: 'overlay',
                }} />
              </div>
              <div style={{ fontSize: 9.5, fontFamily: "'JetBrains Mono', ui-monospace, monospace", color: COLORS.textFaint }}>{i === 0 ? 'noise' : i === STEPS.length - 1 ? 'image' : `step ${i}`}</div>
            </div>
            {i < STEPS.length - 1 && <span style={{ color: COLORS.pink, opacity: 0.6 }}>→</span>}
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Frontier title="Diffusion" models="FLUX · SD3 · Imagen" color={COLORS.pink} />
        <Frontier title="3D / scenes" models="Gaussian Splatting · NeRF" color={COLORS.purple} />
        <Frontier title="Video" models="Sora · Veo · Runway" color={COLORS.indigo} />
      </div>

      <Caption>
        Run perception in reverse and you can <strong>generate</strong>. Diffusion models start from pure noise and
        denoise step-by-step toward an image that matches a text prompt. The same idea now powers 3D scene
        reconstruction (Gaussian splatting) and text-to-video.
      </Caption>
    </div>
  )
}

function Frontier({ title, models, color }) {
  return (
    <Panel glow={color} style={{ padding: '8px 14px' }}>
      <div style={{ fontSize: 13.5, fontWeight: 700, color }}>{title}</div>
      <div style={{ fontSize: 9.5, fontFamily: "'JetBrains Mono', ui-monospace, monospace", color: COLORS.textFaint }}>{models}</div>
    </Panel>
  )
}
